import React from 'react';
import style from '../../css/Contact/Location.module.css';

function Location() {
	return (
		<div className={style.container}>
			<div className={style.card}>
				<div className={style.iconSection}>
					{/* You can use an SVG here for the building icon */}
					<svg width="56" height="56" viewBox="0 0 56 56" fill="none">
						<rect
							x="15"
							y="24"
							width="14"
							height="26"
							stroke="#22135A"
							strokeWidth="2"
							rx="2"
						/>
						<rect
							x="29"
							y="17"
							width="12"
							height="33"
							stroke="#22135A"
							strokeWidth="2"
							rx="2"
						/>
						<rect
							x="41"
							y="32"
							width="6"
							height="18"
							stroke="#22135A"
							strokeWidth="2"
							rx="2"
						/>
						<rect x="17" y="29" width="2" height="4" fill="#22135A" />
						<rect x="17" y="35" width="2" height="4" fill="#22135A" />
						<rect x="17" y="41" width="2" height="4" fill="#22135A" />
					</svg>
				</div>
				<div className={style.infoSection}>
					<h2 className={style.city}>Bangalore</h2>
					<div className={style.address}>8thmile, main road</div>
					<div className={style.cityState}>Bangaloer karnataka - 560025</div>
				</div>
			</div>

			<iframe
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15547.135168340126!2d77.45758014980257!3d13.049429796368141!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3b551adef88f%3A0xcc8f5fd0ae67fc6d!2sMadavara%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1752984573764!5m2!1sen!2sin"
				width="100%"
				height="450"
				allowfullscreen=""
				loading="lazy"
				referrerpolicy="no-referrer-when-downgrade"
				className={style.map}
			></iframe>
		</div>
	);
}

export default Location;
